// extracted by mini-css-extract-plugin
export default {"searchBarWrapper":"SearchBar_searchBarWrapper__49VWW","searchBarText":"SearchBar_searchBarText__jlcGu"};